import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    border: '0',
    fontSize: theme.typography.fontSize,
    display: 'block',
    position: 'relative',
    outline: '0',
    padding: `${theme.spacing(1)} ${theme.spacing(4)} ${theme.spacing(6)}`,
    minHeight: '200px',
    resize: 'none',
  },
}))

/**
 * Styled editable component imported from lexical library
 */
export const LexicalContentEditable: FC = () => {
  const { classes } = useStyles()

  return <ContentEditable className={classes.container} onDragEnter={e => e.preventDefault()} onDragOver={e => e.preventDefault()} />
}
